import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
    AbstractControl,
    ReactiveFormsModule,
    UntypedFormBuilder,
    Validators
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { BusyableButtonComponent } from '../../../../shared/components';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslocoModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        FlexLayoutModule,
        BusyableButtonComponent,
        MatButtonModule,
        MatInputModule
    ]
})
export class LoginComponent implements OnInit {
    @Output() emailOrPhoneProvided = new EventEmitter<string>();

    @Input() busy = false;

    /** Set by the parent when the CAPTCHA could not be completed. */
    @Input() submitFailed = false;

    formGroup = this._fb.group({
        emailOrPhone: [null, Validators.required]
    });

    constructor(
        private readonly _fb: UntypedFormBuilder,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Sign in');
    }

    get emailOrPhone(): AbstractControl | null {
        return this.formGroup.get('emailOrPhone');
    }

    emailOrPhoneSubmitted(): void {
        if (this.formGroup.valid) {
            this.emailOrPhoneProvided.next(this.emailOrPhone?.value);
        }
    }
}
